export const config = {
  title: "Auto Spa of Tampa Bay | Premium Car Detailing in Tampa, FL",
  meta: {
    description:
      "Auto Spa of Tampa Bay provides top-tier mobile and in-shop car detailing services in Tampa, FL. From ceramic coatings to full interior and exterior detailing, we keep your vehicle looking pristine.",
    keywords: [
      'Car Detailing Tampa',
      'Mobile Car Detailing',
      'Ceramic Coating Tampa',
      'Engine Detailing',
      'Boat Detailing',
      'Auto Spa of Tampa Bay',
      'Florida Car Detailing',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Auto Spa of Tampa Bay",
    canonicalUrl: 'https://autospaoftampabay.com/',
  },
  sections: {
    header: {
      businessName: "Auto Spa of Tampa Bay",
    },
    sectionB: {
      heroTitle: "Auto Spa of Tampa Bay",
      heroSubtitle: 'Premium Auto Detailing and Protection Services',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '8139552544',
      phoneLabel: '(813) 955-2544',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1415036627/photo/man-worker-of-car-detailing-studio-removing-scratches-on-car-varnish.jpg?s=612x612&w=0&k=20&c=IKbXC2RTrAHVbCRORGjNJh5ONCHWwjOc2yxJ201vrIM=',
      cardData: [
        {
          title: 'High-Quality Exterior Shine',
          description:
            'We use premium products and techniques to restore and enhance your vehicle’s shine.',
        },
        {
          title: 'Mobile Service Convenience',
          description:
            'Enjoy professional detailing at your home or workplace for maximum convenience.',
        },
        {
          title: 'Complete Stain and Odor Removal',
          description:
            'Deep cleaning and restoration to keep your car’s interior fresh and spotless.',
        },
      ],
      description:
        "At Auto Spa of Tampa Bay, we bring top-notch car detailing services right to your doorstep or in-shop for the ultimate convenience. Our meticulous detailing ensures your vehicle looks flawless inside and out.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "We offer a full range of detailing solutions, from engine cleaning to ceramic coatings, ensuring your vehicle remains in showroom condition.",
      cards: [
        {
          title: 'Engine Detailing',
          description:
            'Improve engine performance and longevity with our thorough cleaning services.',
          imageSrc:
            'https://autospaoftampabay.com/wp-content/uploads/2024/12/01-2.jpg',
          imageAlt: 'Engine Detailing Service',
        },
        {
          title: 'Auto Ceramic Coating',
          description:
            'Protect your car’s paint with long-lasting ceramic coating for a sleek, glossy finish.',
          imageSrc:
            'https://autospaoftampabay.com/wp-content/uploads/2024/12/02-1.jpg',
          imageAlt: 'Ceramic Coating Service',
        },
        {
          title: 'Interior Detailing',
          description:
            'Comprehensive interior detailing to restore and refresh your car’s cabin, including deep cleaning, conditioning, and odor removal.',
          imageSrc:
            'https://autospaoftampabay.com/wp-content/uploads/2024/12/01.jpg',
          imageAlt: 'Interior Detailing Service',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Car Carpet Cleaning',
        'Car Polishing',
        'Car Vacuuming',
        'Car Window Cleaning',
        'Car Waxing',
        'Tire Detailing',
        'Exterior Detailing',
        'Headlight Restoration',
        'Boat Detailing',
        'Mobile Detailing',
        'Paint Protection',
        'Paint Restoration',
        'Scratch Removal',
        'RV Detailing'
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://autospaoftampabay.com/wp-content/uploads/2024/12/01-1.jpg',
        alt: "Auto Spa of Tampa Bay Team",
      },
      aboutText: [
        "Turn Every Drive Into a Showstopper",
        "Auto Spa of Tampa Bay makes your car look and feel brand new with expert detailing services. From ceramic coatings to paint protection and mobile detailing, we offer comprehensive care that keeps your vehicle pristine.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Auto Spa of Tampa Bay Logo",
      businessName: "Auto Spa of Tampa Bay",
      contact: {
        phone: '8139552544',
        phoneLabel: '(813) 955-2544',
        email: 'autospaoftampabay@outlook.com',
        website: 'https://autospaoftampabay.com/',
        address: 'Tampa, FL 33602, USA',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: 'https://www.facebook.com/people/Auto-Spa-of-Tampa-Bay/61563899339855/?mibextid=ZbWKwL',
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Tampa, FL 33602, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3470.8145798346215!2d-82.464897!3d27.950575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c4d74e23f7df%3A0xabcdef123456789!2sTampa%2C%20FL%2033602%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
